import Vue from 'vue'
import router from './router'
import store from './store'
import VCharts from 'v-charts'


Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    store,
    VCharts,
    template: '<router-view/>'
})
